


import { createTheme } from "@mui/material/styles";

let theme = createTheme({
  /* =====================================================
     PALETTE
  ===================================================== */
  palette: {
    primary: { main: "#CD1479" },
    secondary: { main: "#0F3D4C" },

    /* ✅ CUSTOM BRAND COLORS */
    uploadBlue: { main: "#5FA8D3" },
    logoCyan: { main: "#8FD3E8" },
    logoPurple: { main: "#B56BD6" },
    logoPink: { main: "#E56AA6" },
    divider: "#e5e5e5",
    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
    grey: {
      900: "#1A1A1A", // Darkest Grey (Not pure black)
      800: "#2B2B2B", // Aapka existing dark shade
      700: "#404040",
      // ...
    },

    success: { main: "#2E7D32" },
    warning: { main: "#F59E0B" },
    error: { main: "#DC2626" },
    info: { main: "#68d578ff" },

    background: {
      default: "#F7F7F7",
      paper: "#FFFFFF",
    },

    text: {
      primary: "#1F2937",
      secondary: "#6B7280",
      disabled: "#888888",
      orderTitle: "#688AD5",
    },
  },

  /* =====================================================
     TYPOGRAPHY (INCREASED & SAFE)
  ===================================================== */
  typography: {
    fontFamily: "Verdana, sans-serif",

    fontSize: 18, 

    // /* ===== HEADINGS ===== */
    // h1: { fontWeight: 700, fontSize: "1.625rem" }, // 26px
    // h2: { fontWeight: 600, fontSize: "1.375rem" }, // 22px
    // h3: { fontWeight: 600, fontSize: "1.25rem" },  // 20px
    // h4: { fontWeight: 600, fontSize: "1.125rem" }, // 18px

    // /* ===== TEXT ===== */
    // body1: { fontWeight: 600, fontSize: "1rem" },      // 16px
    // body2: { fontWeight: 400, fontSize: "0.9375rem" }, // 15px

    /* ===== SMALL TEXT ===== */
    // caption: { fontSize: "0.95rem" }, // 13px
    // overline: {
    //   fontSize: "0.75rem", // 12px
    //   textTransform: "none",
    // },


  },

  /* =====================================================
     SHAPE
  ===================================================== */
  shape: {
    borderRadius: 12,
  },

  /* =====================================================
     GLOBAL TOKENS
  ===================================================== */
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: "18px", // 🔒 Mac = Windows
          WebkitTextSizeAdjust: "100%",
          textSizeAdjust: "100%",
        },
        body: {
          backgroundColor: "#F7F7F7",
          margin: 0,
          padding: 0,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },

        ":root": {

          "--color-primary": "#CD1479",
          "--color-primary-hover": "#B01268",
          " --color-primary-disabled": "#F0A6C9",
          "--color-secondary": "#8FD3E8",

          "--color-white": "#ffffff",
          "--color-primary-soft": "#CD14790F",
          "--btn-success": "#2E7D32",
          "--btn-success-hover": "#256628",

          "--btn-secondary": "#1876d2",
          "--btn-secondary-hover": "#4691DB",


          "--black": "#000000",
          "--black-muted": "#2B2B2B",
          "--text-muted": "#808080",
          "--muted-strong": "#00121a",
          "--text-disabled": "#9e9e9e",
          /* SURFACE / CARD BACKGROUND */
          "--color-surface-light": "#F0F0F4",
          "--offline-text": "#688AD5",
          /* FONT WEIGHTS */
          // orderlistcard
          "--color-teal-dark": "#002b3a",
          "--color-border": "#e5e5e5",
          "--bg-table-header": "#F9FAFB",
          /* ===== FONT WEIGHTS ===== */
          "--fw-light": "300",
          "--fw-regular": "400",
          "--fw-semibold": "500",
          "--fw-bold": "600",
          /* ===== FONT SCALE (RESPONSIVE – REDUCED & BALANCED) ===== */
          "--fs-xxs": "clamp(0.6rem, 0.25vw, 0.7rem)",   /* 9.6px → 11.2px */
          "--fs-xs": "clamp(0.7rem, 0.4vw, 0.8rem)",    /* 11.2px → 12.8px */
          "--fs-sm": "clamp(0.8rem, 0.6vw, 0.95rem)",   /* 12.8px → 15.2px */
          "--fs-md": "clamp(0.9rem, 0.8vw, 1.05rem)",   /* 14.4px → 16.8px */
          "--fs-lg": "clamp(1rem, 1vw, 1.2rem)",    /* 16px → 19.2px */





          /* ===== SPACING ===== */
          "--space-xs": "4px",
          "--space-sm": "8px",
          "--space-md": "12px",
          "--space-lg": "16px",

          /* ===== RADIUS ===== */
          "--radius-sm": "6px",
          "--radius-md": "10px",
          "--radius-lg": "12px",
          "--radius-xl": "16px",

          ":root": {
            /* ===== TABLE TYPOGRAPHY TOKENS ===== */
            "--fs-table-head": "var(--fs-xs)",   // header text
            "--fs-table-body": "var(--fs-sm)",   // body text
            "--fs-table-chip": "var(--fs-xs)",   // status chip

            /* ===== CONTENT / PAGE ===== */
            "--fs-content-title": "2rem",
            "--fs-content-text": "var(--fs-xs)",
            "--fs-content-secondary": "var(--fs-sm)",
          },

        },
      },
    },

    /* =====================================================
       BUTTON
    ===================================================== */
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 200,
          fontSize: "0.9375rem", // 15px
          padding: "10px 16px",
        },
      },
    },

    /* =====================================================
       CARD
    ===================================================== */
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
        },
      },
    },

    /* =====================================================
       PAGINATION (table prev/next arrows)
    ===================================================== */
    MuiTablePagination: {
      styleOverrides: {
        actions: {
          "& .MuiIconButton-root": {
            backgroundColor: "#CD1479",
            color: "#FFFFFF",
            borderRadius: "8px",
            margin: "0 4px",
            "&:hover": {
              backgroundColor: "#B01268",
            },
            "&.Mui-disabled": {
              backgroundColor: "#F0A6C9",
              color: "#FFFFFF",
            },
          },
        },
      },
    },

    /* =====================================================
       PAGINATION (numbered page picker, e.g. POS product grid)
    ===================================================== */
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#CD1479",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#B01268",
            },
          },
        },
      },
    },
  },
});

export default theme;
